import { analytics } from '@/utils/pixels/analytics';
import { bingads } from '@/utils/pixels/bingads';
import { criteo } from '@/utils/pixels/criteo';
import { facebook } from '@/utils/pixels/facebook';
import { googleads } from '@/utils/pixels/googleads';
import { outbrain } from '@/utils/pixels/outbrain';
import { taboola } from '@/utils/pixels/taboola';
import { tagmanager } from '@/utils/pixels/tagmanager';
import { tiktok } from '@/utils/pixels/tiktok';
import { gtag } from '@/api';

export const injectPixelScript = (identifier, event) => {
  try {
    identifier = JSON.parse(JSON.stringify(identifier))

    identifier.forEach(element => {
      const value = getPixel(element, event)
      firePixel(value.pixel, value.type)
    });
  } catch (error) {
    throw new Error(error)
  }
}

function getPixel(pixel, event) {
  let type = ''

  Object.entries(pixel).forEach(([key, value]) => {
    value.events = value.events.filter(events => event == events.type || events.type === 'allPages')
    type = value.type
  })

  return {pixel, type}
}

function firePixel(pixel, type) {
  switch (type) {
    case 'analytics': 
      fetchGtag(Object.keys(pixel)[0])  
      analytics(pixel);
      break;
    case 'bingads': 
      bingads(pixel); 
      break;
    case 'criteo': 
      criteo(pixel); 
      break;
    case 'facebook': 
      facebook(pixel); 
      break;
    case 'googleads':
      fetchGtag(Object.keys(pixel)[0])
      googleads(pixel); 
      break;
    case 'outbrain': 
      outbrain(pixel); 
      break;
    case 'taboola': 
      taboola(pixel); 
      break;
    case 'tagmanager': 
      tagmanager(pixel); 
      break;
    case 'tiktok': 
      tiktok(pixel); 
      break;
    default: break;
  }
}

function fetchGtag(pixelId) {
  gtag.get(`js?id=${pixelId}`)
}
